/**
 * GiftCardsTableCustomerCell — the Customer column of the gift-cards table
 * (BON-223): name + email, or the italic "No customer linked" placeholder for
 * an unregistered gift card.
 */
import type { GiftCardListRow } from './giftCardTypes';

export function GiftCardsTableCustomerCell({
  customer,
}: {
  customer: GiftCardListRow['customer'];
}) {
  if (!customer?.name) {
    return (
      <span style={{ fontSize: 12, color: 'var(--nb-faint)', fontStyle: 'italic' }}>
        No customer linked
      </span>
    );
  }
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontWeight: 600, fontSize: 13 }}>{customer.name}</div>
      {customer.email && (
        <div
          style={{
            fontSize: 11,
            color: 'var(--nb-subtle)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 260,
          }}
        >
          {customer.email}
        </div>
      )}
    </div>
  );
}
